import React, { useState, useCallback } from "react";
import { useSearchParams } from "react-router-dom";

import { toast } from "react-toastify";
import { callPostApi } from "../../function/ApiCallFunction";

import Swal from "sweetalert2";
import discoball from "../../assets/discoball.png";
import cashilogo from "../../assets/cashiblack.png";

import "./storeReview.css";

/* ---------- Reusable Components ---------- */

const Input = ({ label,error, ...props }) => (<div className={`section ${error ? "error" : ""}`}><label>{label}</label><input {...props} /></div>);

const StarRating = ({ label, value, onRate ,error}) => (
    <div className={`section ${error ? "error" : ""}`}>
      <label>{label}</label>
      <div className="stars"> {[1, 2, 3, 4, 5].map((i) => ( <span key={i} className={i <= value ? "active" : ""} onClick={() => onRate(i)} > ★ </span>  ))} </div>
    </div>
);

const EmojiRating = ({ label, value, onRate,error }) => {
  const emojis = ["😡", "😕", "😐", "😊", "😍"];

  return (
    <div className={`section ${error ? "error" : ""}`}>
      <label>{label}</label>
      <div className="emoji-rating">
          {emojis.map((e, i) => ( <span key={i} className={i + 1 === value ? "active" : ""} onClick={() => onRate(i + 1)} >{e}</span>))}
      </div>
    </div>
  );
};

const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

/* ---------- Main Component ---------- */

const CustReviewAdd = () => 
{
  const [searchParams] = useSearchParams();
  const store_id = searchParams.get("id");

  const [touched, setTouched] = useState(false);
  const [ratings, setRatings] = useState({ shopping: 0, product: 0, staff: 0 });
  const [form,    setForm]    = useState({ name: "", email: "", phone: "", comment: "" });
  const [loading, setLoading] = useState(false);

  /* ---------- Handlers ---------- */

  const handleRating = useCallback((type, value) => { setRatings((prev) => ({ ...prev, [type]: value })); }, []);

  const handleChange = useCallback((e) => 
  {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }, []);

  const submitReview = async () => 
  {
      setTouched(true);

      if (!store_id) { toast.error("Invalid QR link"); return; }

      if (!form.name || !ratings.shopping || !ratings.product || !ratings.staff)   { toast.error("Please fill all required fields");   return; }

      // ✅ Email validation ONLY if entered
      if (form.email && !isValidEmail(form.email)) { toast.error("Please enter a valid email address"); return; }

      setLoading(true);

      const payload = { mod: "STORE_REVIEW_ADD", data_arr: {store_id,...form,shoppingRating: ratings.shopping,productRating: ratings.product,staffRating: ratings.staff,},};

      try 
      {
          const response = await callPostApi("store-review", payload);

          if (String(response?.status) === "200") 
          {
            const { store_name } = response.data.success;

            Swal.fire({
            html: ` <div style="text-align:center;">
                    <p style="font-weight:bold;font-size:1.25em">${store_name}</p>
                    <img src="${discoball}" width="140" alt="discoball" />
                    <p>Thank you! Your review has been submitted</p>
                    </div>
            `,
            confirmButtonColor: "#0f172a",
            allowOutsideClick: false,
            });

            setForm({ name: "", email: "", phone: "", comment: "" });
            setRatings({ shopping: 0, product: 0, staff: 0 });
          } 
          else { toast.error(response?.status_message || "Something went wrong"); }
      } 
      catch { toast.error("API Error while saving."); } 
      finally { setLoading(false); }
  };

  /* ---------- JSX ---------- */

  return (
    <div className="reviewpage">
      <div className="review-card">
        <h2>Share Your Experience</h2>
        <p className="subtitle">We’d love to hear from you</p>

        <Input label="👤 Your Name" name="name" value={form.name} onChange={handleChange} required  error={touched && !form.name}/>
        <Input label="📧 Email Address" type="email" name="email"  value={form.email} onChange={handleChange} 
              error={touched && form.email && !isValidEmail(form.email)} />
        
        <Input label="📱 Phone Number" type="tel" name="phone" inputMode="numeric" maxLength={10} value={form.phone} 
                onChange={(e) => {  const value = e.target.value;
                    if (/^\d*$/.test(value)) { handleChange(e); } }} />

        <StarRating label="🛍️ Shopping Experience" value={ratings.shopping} onRate={(v) => handleRating("shopping", v)}  error={touched && !ratings.shopping} />
        <StarRating label="📦 Product Availability" value={ratings.product} onRate={(v) => handleRating("product", v)} error={touched && !ratings.product} />
        <EmojiRating label="👨‍🍳 Staff Behaviour" value={ratings.staff} onRate={(v) => handleRating("staff", v)}  error={touched && !ratings.staff} />

        <div className="section">
            <label>✍️ Additional Comments</label>
            <textarea name="comment" value={form.comment} placeholder="Tell us about shopping, product, ambience..." onChange={handleChange} />
        </div>

        <button disabled={loading} onClick={submitReview}> {loading ? "Submitting..." : "Submit Review"} </button>

        <div className="footer">Thank you for visiting us Powered by <img src={cashilogo} alt="CASHI" href='www.cashi.in' style={{height:'11px'}} /></div>
      </div>
    </div>
  );
};

export default CustReviewAdd;
